import { PatientId, WithPatientId } from '../surgicalEvent.slice';
import { doctorBffApi, InvalidateArr } from '@/modules';
import { AnesthesiaInfoService } from '@/modules/surgicalEvent';
import { AnesthesiaInfo, AnesthesiaRisk } from './anesthesiaInfo.model';
import { wrapError } from '../../error';

const anesthesiaApi = doctorBffApi.injectEndpoints({
  endpoints: (builder) => ({
    anesthesiaInfo: builder.query<AnesthesiaInfo, PatientId>({
      queryFn: ({ patientId }) =>
        AnesthesiaInfoService.getInstance(patientId).fetch().catch(wrapError),
      providesTags: (result, error, { patientId }) => [
        { type: 'AnesthesiaInfo', id: patientId }
      ]
    }),

    patchAnesthesiaInfo: builder.mutation<
      AnesthesiaInfo,
      WithPatientId<Partial<AnesthesiaInfo>>
    >({
      queryFn: ({ patientId, ...anesthesiaInfo }) =>
        AnesthesiaInfoService.getInstance(patientId)
          .patch(anesthesiaInfo)
          .catch(wrapError),
      invalidatesTags: (result, error, { patientId, ...payload }) => {
        const arr: InvalidateArr = [
          { type: 'AnesthesiaInfo', id: patientId },
          'Dashboard'
        ];

        if (
          payload.plannedAnesthesiaTypes !== undefined ||
          payload.userInputPlannedAnesthesiaTypes !== undefined ||
          payload.combinedOrderedPlannedAnesthesiaTypes !== undefined
        ) {
          arr.push({ type: 'Meds', id: patientId });
        }

        return arr;
      }
    }),

    anesthesiaRisks: builder.query<AnesthesiaRisk, PatientId>({
      queryFn: ({ patientId }) =>
        AnesthesiaInfoService.getInstance(patientId)
          .fetchRisks()
          .catch(wrapError),
      providesTags: (result, error, { patientId }) => [
        { type: 'AnesthesiaRisk', id: patientId }
      ]
    }),

    patchAnesthesiaRisk: builder.mutation<
      AnesthesiaRisk,
      WithPatientId<Partial<AnesthesiaRisk>>
    >({
      queryFn: ({ patientId, ...anesthesiaRisk }) =>
        AnesthesiaInfoService.getInstance(patientId)
          .patchRisks(anesthesiaRisk)
          .catch(wrapError),
      invalidatesTags: (result, error, { patientId }) => [
        { type: 'AnesthesiaRisk', id: patientId },
        'Dashboard'
      ]
    })
  }),
  overrideExisting: false
});

export const {
  useAnesthesiaInfoQuery,
  usePatchAnesthesiaInfoMutation,
  useAnesthesiaRisksQuery,
  usePatchAnesthesiaRiskMutation
} = anesthesiaApi;
